export default __webpack_public_path__ + "static/media/logo_svg.21881bf6.svg";